import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RoiSetting} from '../../../../../../models/measure/roi-report';
import {ReferenceDataService} from '../../../../../services/reference-data/reference-data.service';
import {UserService} from '../../../../../services/user.service';
import {CommonConstant} from '../../../../../app.constants';
import {MeasureService} from '../../../../../services/measure/measure.service';
import {NumberUtils} from '../../../../../utils/number.utils';

@Component({
  selector: 'roi-setting',
  templateUrl: './roi-setting.component.html',
  styleUrls: ['./roi-setting.component.scss']
})
export class RoiSettingComponent {

  @Input()
  public roiSetting: RoiSetting;

  public calculationMethods = CommonConstant.CPM_CALCULATION_METHODS;

  public currencies = CommonConstant.CURRENCIES;

  get selectedCurrency() {
    if (!this.roiSetting) {
      return '';
    }

    switch (this.roiSetting.currency) {
      case 0:
        return '€';
      case 1:
        return '$';
      case 2:
        return CommonConstant.DANISH_KRONE_CURRENCY;
      case 3:
        return CommonConstant.NORWAY_CURRENCY;
      case 4:
        return CommonConstant.SWEDISH_CURRENCY;
      case 5:
        return CommonConstant.POUND_CURRENCY;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/content/roi-report/roi-setting/roi-setting.component.ts